import React, { useCallback, useRef } from 'react';
import { useLaunchGame } from 'js/hooks/gameLauncher';
import { AccessibilityElement } from 'js/components/common/AccessibilityElement';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import style from './LineItem.scss';

export const LineItem = (props) => {
    const { gameCode: code, player, winAmount, gameName, showSeparator } = props;
    const winnerRef = useRef();
    const launchGame = useLaunchGame();
    const translate = useComponentTranslations();

    const openGame = useCallback(() => {
        launchGame({ code, mode: 1 });

        // for accessibility: if game is opened in new window, focus stays on line and line doesn't run
        winnerRef.current?.blur();
    }, [code, launchGame]);

    return (
        <>
            <AccessibilityElement
                inline={true}
                onClick={openGame}
                elementRef={winnerRef}
                className={style.topWinner}
                aria-label={`${translate('playtech.mobile.system.game.aria-label')} ${gameName}`}
            >
                {`${player} ${translate('justWon')} `}
                <span className={style.winAmount}>{winAmount}</span>
                {` ${translate('inGame')} ${gameName}`}
            </AccessibilityElement>
            {showSeparator && (
                <span className={style.separator}>
                    {translate('lineView.separator')}
                </span>
            )}
        </>
    );
};
